import { render, staticRenderFns } from "./buttons-common.vue?vue&type=template&id=b1898e42&scoped=true&"
import script from "./buttons-common.vue?vue&type=script&lang=js&"
export * from "./buttons-common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1898e42",
  null
  
)

export default component.exports